import { z } from 'zod';
/**
 * Extended data classification. First 4 values are backward compatible
 * with the existing classification schema.
 */
export const DATA_CLASSES = [
    // Existing (backward compatible)
    'pii', 'phi', 'financial', 'biometric',
    // GDPR Art. 9 special categories
    'racial_ethnic_origin', 'political_opinions', 'religious_beliefs',
    'trade_union', 'genetic', 'health', 'sexual_orientation',
    // Domain-specific
    'legal_records', 'privileged_communications', 'criminal_records',
    'employment_records', 'student_records', 'critical_infrastructure_data',
    'behavioral_data', 'location_data', 'content_data',
];
export const dataClassSchema = z.array(z.enum(DATA_CLASSES)).default([]);
/** GDPR Art. 9 special categories — a proper subset of DATA_CLASSES. */
export const GDPR_SPECIAL_CATEGORIES = [
    'racial_ethnic_origin', 'political_opinions', 'religious_beliefs',
    'trade_union', 'genetic', 'health', 'sexual_orientation',
    'biometric',
];
export const DATA_CLASS_LABELS = {
    pii: 'Personally Identifiable Information',
    phi: 'Protected Health Information',
    financial: 'Financial Data',
    biometric: 'Biometric Data',
    racial_ethnic_origin: 'Racial & Ethnic Origin',
    political_opinions: 'Political Opinions',
    religious_beliefs: 'Religious & Philosophical Beliefs',
    trade_union: 'Trade Union Membership',
    genetic: 'Genetic Data',
    health: 'Health Data',
    sexual_orientation: 'Sexual Orientation',
    legal_records: 'Legal Records',
    privileged_communications: 'Privileged Communications',
    criminal_records: 'Criminal Records',
    employment_records: 'Employment Records',
    student_records: 'Student Records',
    critical_infrastructure_data: 'Critical Infrastructure Data',
    behavioral_data: 'Behavioral Data',
    location_data: 'Location Data',
    content_data: 'Content Data',
};
//# sourceMappingURL=data-classes.js.map